import { inject, Injectable, signal } from '@angular/core';
import Pusher from 'pusher-js';

import { NotificationService } from '#core/components/notification-center/services/notifications.service';
import { environment } from '#environments/environment';

@Injectable({ providedIn: 'root' })
export class RealtimeMessagingService {
    private readonly _API_BASE_URL = `${environment.APP_MALOU_API_URL}/api/v1`;
    private readonly _notificationService = inject(NotificationService);

    private readonly _pusherClient = signal<Pusher | undefined>(undefined);
    readonly pusherClient = this._pusherClient.asReadonly();
    private _isInitialized = false;

    initializeIfNeeded(userId: string): void {
        if (this._isInitialized) {
            return;
        }
        this._isInitialized = true;
        const currentClient = this._pusherClient();
        if (currentClient) {
            currentClient.disconnect();
        }
        const client = new Pusher(environment.PUSHER_KEY, {
            cluster: 'eu',
            authEndpoint: `${this._API_BASE_URL}/messages/pusher/auth`,
        });
        this._pusherClient.set(client);
        // Messages are now initialized in the RestaurantLayoutComponent
        this._notificationService.initRealtimeNotifications(client, userId);
    }

    disconnect(): void {
        this._pusherClient()?.disconnect();
        this._notificationService.disconnect();
        this._isInitialized = false;
    }
}
